import { BehaviorSubject } from 'rxjs';
import { Flight } from '@ibe/models';
import { MybService, BookingService } from '@ibe/services';
import { takeWhile } from 'rxjs/operators';
import { TAPDataStorageService } from '@ibe/services/mocks.tap';
import * as i0 from "@angular/core";
import * as i1 from "./myb.tap.service";
import * as i2 from "./mocks.tap/data-storage.tap.service";
import * as i3 from "./booking.tap.service";
var ChangeFlightService = /** @class */ (function () {
    function ChangeFlightService(mybService, storage, bookingService) {
        var _this = this;
        this.mybService = mybService;
        this.storage = storage;
        this.bookingService = bookingService;
        this.isAlive = true;
        this._new_booked_trip_flights = [];
        this.booked_trip = new BehaviorSubject(this._booked_trip);
        this.new_booked_trip_flights = new BehaviorSubject(this._new_booked_trip_flights);
        this.isBookedTripsLoaded = new BehaviorSubject(this._isBookedTripsLoaded);
        this.pnr = new BehaviorSubject(this._pnr);
        this.selectedFlights = new BehaviorSubject(this._selectedFlights);
        this.selectedPassengers = new BehaviorSubject(this._selectedPassengers);
        this.bookingService.current_step$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (current_step) {
            _this._current_step = current_step;
        });
        // this.storage.initializeActiveBookingIfEmpty();
        // this.bookingTrip = storage.observableCurrentBooking;
    }
    /** Reset Change Flight operation */
    ChangeFlightService.prototype.resetChangeFlight = function () {
        this._isBookedTripsLoaded = false;
        this.isBookedTripsLoaded.next(this._isBookedTripsLoaded);
        this.setSelectedFlights(undefined);
        this.setSelectedPassengers(undefined);
        this.setBooking();
    };
    /** Set booking PNR */
    ChangeFlightService.prototype.setPNR = function (pnr) {
        this._pnr = pnr;
        this.pnr.next(this._pnr);
    };
    /** Set Selected Flights */
    ChangeFlightService.prototype.setSelectedFlights = function (flights) {
        this._selectedFlights = flights;
        this.selectedFlights.next(this._selectedFlights);
    };
    /** Set Selected Flights */
    ChangeFlightService.prototype.getSelectedFlights = function () {
        return this._selectedFlights;
    };
    /** Set Selected Passengers */
    ChangeFlightService.prototype.setSelectedPassengers = function (passengers) {
        this._selectedPassengers = passengers;
        this.selectedPassengers.next(this._selectedPassengers);
    };
    ChangeFlightService.prototype.getSelectedPassengers = function () {
        return this._selectedPassengers;
    };
    /** Get booking PNR */
    ChangeFlightService.prototype.getPNR = function () {
        return this._pnr;
    };
    /**
     * Get booking from PNR
     * @param {string} pnr of booking
     * @returns booking trip
     */
    ChangeFlightService.prototype.getBooking = function (pnr) {
        return this.storage.getBookedTrip(pnr);
    };
    ChangeFlightService.prototype.initializeBookingToChange = function () {
        var _this = this;
        var self = this;
        // Subscribe to know when the mocked trips are loaded
        this.mybService.isBookedTripsLoaded.subscribe(function (data) {
            _this._isBookedTripsLoaded = data;
            if (_this._isBookedTripsLoaded) {
                _this.isBookedTripsLoaded.next(_this._isBookedTripsLoaded);
                self.setBooking.call(self);
            }
        });
        this.mybService.observableTrips
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (_) { }, function (error) { return console.error(error); }, function () { });
    };
    /**
     * Get booking from service using PNR
     */
    ChangeFlightService.prototype.setBooking = function () {
        if (this.getBooking(this._pnr)) {
            this._booked_trip = this.getBooking(this._pnr);
            this.booked_trip.next(this._booked_trip);
        }
    };
    /**
     * Get current changing booking from service
     */
    ChangeFlightService.prototype.getChangingBooking = function () {
        return this._booked_trip;
    };
    ChangeFlightService.prototype.getFlights = function (params) {
        return this.bookingService.getFlights(params);
    };
    /**
     * Sets the flight and flight date for the indicated index
     * @param flight Flight object to add to this._flights
     * @param index Flight index. If null, will use current_step
     * @param time Time of the flight. Should be sent explicitly
     * in case flight object changes.
     */
    ChangeFlightService.prototype.setFlight = function (flight, time, index) {
        if (index === void 0) { index = this._current_step; }
        var FLIGHT_INDEX_ON_BOOKING = this._current_step;
        var neue_flight = new Flight(flight.departure, flight.arrival, flight.number);
        Object.assign(neue_flight, flight);
        neue_flight.update = 'new-flight';
        neue_flight.status = 'scheduled';
        neue_flight.check_in = { status: 'open', time: time };
        neue_flight.passengerInfo = this._booked_trip.flights[FLIGHT_INDEX_ON_BOOKING].passengerInfo;
        this._new_booked_trip_flights.push({
            flight: neue_flight,
            index: FLIGHT_INDEX_ON_BOOKING
        });
        this.new_booked_trip_flights.next(this._new_booked_trip_flights);
        this.bookingService.updateStepFlight(time, index);
        this.bookingService.goToNextStep();
    };
    /** Confirm Change Flight operation */
    ChangeFlightService.prototype.confirmChangeFlight = function () {
        var _loop_1 = function (index) {
            var FLIGHT_INDEX_ON_BOOKING = this_1._selectedFlights[index].index;
            var NEW_FLIGHT = this_1._new_booked_trip_flights.filter(function (flight) { return flight.index === FLIGHT_INDEX_ON_BOOKING; });
            this_1._booked_trip.flights[FLIGHT_INDEX_ON_BOOKING] = NEW_FLIGHT[0].flight;
        };
        var this_1 = this;
        for (var index = 0; index < this._selectedFlights.length; index++) {
            _loop_1(index);
        }
        this.storage.updateBooking(this._pnr, this._booked_trip);
        this.resetChangeFlight();
    };
    ChangeFlightService.ngInjectableDef = i0.defineInjectable({ factory: function ChangeFlightService_Factory() { return new ChangeFlightService(i0.inject(i1.MybService), i0.inject(i2.TAPDataStorageService), i0.inject(i3.BookingService)); }, token: ChangeFlightService, providedIn: "root" });
    return ChangeFlightService;
}());
export { ChangeFlightService };
